import "./BisCard.css";
import PropTypes from "prop-types";


const BisCard = ({child}) => {

    return (
        <div className="card-container">
            {child}
        </div>
    );
}

BisCard.propTypes = {
    child: PropTypes.node.isRequired,
};

export default BisCard;
